module.exports = __webpack_public_path__ + "img/4.e847c9a.png";